import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from 'styled-components';
import { Form, Space } from 'antd';
import { getSize, getColor } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
// Styles
var StyledSpaceContainer = styled(Space).withConfig({
  displayName: "card-layoutcomponent__StyledSpaceContainer",
  componentId: "sc-7n5n8q-0"
})(["position:relative;display:flex;flex-direction:column;width:100%;.sticky-element1{position:absolute;top:", ";left:", ";visibility:hidden;z-index:100;}"], getSize('padding0'), getSize('padding0'));
var StyledSectionWrapperContainer = styled.div.withConfig({
  displayName: "card-layoutcomponent__StyledSectionWrapperContainer",
  componentId: "sc-7n5n8q-1"
})(["position:relative;margin-top:", ";"], getSize('padding0'));
var StyledSectionWrapper = styled(Form).withConfig({
  displayName: "card-layoutcomponent__StyledSectionWrapper",
  componentId: "sc-7n5n8q-2"
})(["position:relative;border:1px solid #e5e7eb;background:", ";border-radius:", ";transition:box-shadow 0.2s ease;box-shadow:0px 3px 6px rgba(0,0,0,0.12);"], getColor('fillBgWhite'), getSize('typo12'));
var StyledSection = styled.div.withConfig({
  displayName: "card-layoutcomponent__StyledSection",
  componentId: "sc-7n5n8q-3"
})(["padding:", ";border-top:", ";border-radius:", ";transition:border-top 0.2s ease;"], getSize('padding16'), function (_ref) {
  var theme = _ref.theme,
      $focus = _ref.$focus;
  return $focus ? "6px solid ".concat(getColor('fillIntActive')({
    theme: theme
  })) : 'none';
}, getSize('radiusSm'));
export var StyledCardContainer = styled.div.withConfig({
  displayName: "card-layoutcomponent__StyledCardContainer",
  componentId: "sc-7n5n8q-4"
})(["display:flex;justify-content:space-between;align-items:center;"]);
export var StyledAudioWrapper = styled.div.withConfig({
  displayName: "card-layoutcomponent__StyledAudioWrapper",
  componentId: "sc-7n5n8q-5"
})(["margin-top:", ";"], getSize('padding16'));
export var StyledAudioLabel = styled.div.withConfig({
  displayName: "card-layoutcomponent__StyledAudioLabel",
  componentId: "sc-7n5n8q-6"
})(["margin-bottom:", ";color:", ";font-size:", ";font-weight:700;"], getSize('padding8'), getColor('contentBody'), getSize('typo14')); // Component

export var CardLayout = function CardLayout(_ref2) {
  var children = _ref2.children,
      isFocused = _ref2.isFocused,
      onMouseEnter = _ref2.onMouseEnter,
      onMouseLeave = _ref2.onMouseLeave,
      onClick = _ref2.onClick,
      formProps = _ref2.formProps,
      onGetPositionElement = _ref2.onGetPositionElement,
      sectionId = _ref2.sectionId;
  return /*#__PURE__*/_jsx(StyledSpaceContainer, {
    direction: "vertical",
    size: "middle",
    onClick: onGetPositionElement,
    children: /*#__PURE__*/_jsx(StyledSectionWrapperContainer, {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      children: /*#__PURE__*/_jsx(StyledSectionWrapper, _objectSpread(_objectSpread({}, formProps), {}, {
        children: /*#__PURE__*/_jsx(StyledSection, {
          $focus: isFocused,
          onClick: onClick,
          id: sectionId,
          children: children
        })
      }))
    })
  });
};